import { render, staticRenderFns } from "./OrderSign.vue?vue&type=template&id=5a1a1d49"
import script from "./OrderSign.vue?vue&type=script&lang=js"
export * from "./OrderSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports